import { AUTH, NOTIFY } from '../constants/toadConstants';


const ToadReducer = (state, action) => {
  switch (action.type) {
    case NOTIFY:
      return {
        ...state,
        notify: action.payload,
      };
    case AUTH:
      return {
        ...state,
        auth: action.payload,
      };

    default:
      return state;
  }
};

export default ToadReducer;